import './styles/index.scss';
import { createRoutesView } from 'atomic-router-react';
import compose from 'compose-function';
import { lazy } from 'react';
import { GAME_PAGE_MAIN_ID, GAME_PAGE_WRAPPER_ID, GamePage } from 'pages/game-page';
import { ResultPage } from 'pages/result-page';
import { CalculatorBet } from 'widgets/calculator-bet';
import { FairnessModal, FairnessModalButton } from 'widgets/fairness-modal';
import { GameHelpModal, GameHelpModalButton } from 'widgets/game-help-modal';
import { HighrollersModal, HighrollersModalButton } from 'widgets/highrollers-modal';
import { Loader } from 'widgets/loader';
import { MyBetsModal, MyBetsModalButton } from 'widgets/my-bets-modal';
import { OnboardingModal } from 'widgets/onboarding-modal';
import { Sidebar } from 'widgets/sidebar';
import { IS_DEV, IS_LOCAL } from 'shared/config';
import { gameRoute, resultRoute } from 'shared/routes';
import {
	withTheme,
	withTranslations,
	withNotifications,
	withRouter,
	withLandscapeOverlay,
	withErrorModal,
} from './providers';

const DevTools = IS_DEV || IS_LOCAL ? lazy(() => import('widgets/dev-tools')) : () => null;

export const withProviders = compose(
	withTranslations,
	withTheme,
	withNotifications,
	withLandscapeOverlay,
	withErrorModal,
);

const MainContent = withProviders(() => (
	<>
		<GamePage />
		<Loader />
		<Sidebar
			targetId={GAME_PAGE_MAIN_ID}
			topSlot={
				<>
					<MyBetsModalButton />
					<HighrollersModalButton />
				</>
			}
			bottomSlot={
				<>
					<FairnessModalButton />
					<GameHelpModalButton />
				</>
			}
		/>
		<CalculatorBet targetId={GAME_PAGE_WRAPPER_ID} />
		<OnboardingModal targetId={GAME_PAGE_MAIN_ID} />
		<MyBetsModal targetId={GAME_PAGE_MAIN_ID} />
		<HighrollersModal targetId={GAME_PAGE_MAIN_ID} />
		<FairnessModal targetId={GAME_PAGE_MAIN_ID} />
		<GameHelpModal targetId={GAME_PAGE_MAIN_ID} />
		<DevTools />
	</>
));

const RoutesView = createRoutesView({
	routes: [
		{ route: gameRoute, view: MainContent },
		{ route: resultRoute, view: ResultPage },
	],
});

export const App = withRouter(() => <RoutesView />);
